import React from 'react';
import styled from 'styled-components';
import { media, TransitionMixin } from '../helpers';

const FooterStylesContainer = styled.footer`
    padding: 0 0 100px;
    background-color: #eceae4;
    position: relative;
    .svg-container {
        background-color: #fff;
        line-height: 1;
        svg {
            width: 100%;
            height: auto;
            position: relative;
            bottom: -2px;

            g {
                mask: none;
            }
        }
    }
    .top-footer-wrapper {
        ${media.medium`display: flex; max-width: 75vw;`}
        padding: 50px 0;

        .left-container {
            flex: 1;
            .mobile-footer-logo-container {
                margin-bottom: 35px;
                ${media.medium`display: none;`}
                svg {
                    max-width: 200px;
                    height: auto;
                    width: 100%;
                    path {
                        fill: #000;
                    }
                }
            }

            .footer-links-container {
                display: flex;
                flex-wrap: wrap;
                margin-bottom: 40px;
                align-items: flex-start;
                ${media.medium`align-items: flex-start; display: inline-flex;`}
                .desktop-footer-logo-container {
                    margin-bottom: 35px;
                    display: none;
                    flex: 1 1 100%;
                    ${media.medium`display: block;`}
                    svg {
                        max-width: 200px;
                        height: auto;
                        width: 100%;
                        path {
                            fill: #000;
                        }
                    }
                }

                .list-container {
                    flex: 1;
                    ul {
                        margin: 0;
                        padding: 0;
                        list-style: none;
                        li {
                            margin-bottom: 20px;
                            &:last-child {
                                margin-bottom: 0px;
                            }
                            a {
                                color: #000;
                                font-weight: 800;
                                text-decoration: none;
                                font-size: 1rem;
                                font-family: 'neue-kabel', sans-serif;
                                ${TransitionMixin('.25s')}
                                &:hover {
                                    opacity: 0.7;
                                }
                            }
                        }
                    }
                    &:nth-child(3) {
                        li {
                            &:last-child {
                                margin-bottom: 0px;
                                a {
                                    color: #ff9905;
                                }
                            }
                        }
                    }
                }
            }
        }

        .right-container {
            flex: 1;

            > .inner-wrap {
                max-width: 450px;
                margin-left: auto;

                .footer-form-container {
                    margin-bottom: 40px;
                    h4 {
                        margin: 0 0 20px;
                        text-transform: uppercase;
                        color: #000;
                        font-size: 0.9rem;
                    }

                    form {
                        margin-bottom: 0px;
                        .input-row {
                            .input-container {
                                display: flex;
                                input {
                                    flex: 4;
                                    height: 60px;
                                    padding-left: 15px;
                                    margin-right: 10px;
                                    border-radius: 5px;
                                    border: none;
                                    background-color: #e0e0e0;
                                    color: #702716;
                                }

                                button {
                                    flex: 1;
                                    font-weight: bold;
                                    background-color: #f74c34;
                                    border: 1px solid #f74c34;
                                    color: #fff;
                                    border-radius: 5px;
                                    min-width: 110px;
                                    font-weight: 800;
                                    font-family: neue-kabel, sans-serif;
                                }
                            }
                        }
                    }
                }
                .social-row {
                    display: flex;
                    align-items: flex-end;
                    .social-container {
                        flex: 1;
                        h4 {
                            color: #000;
                            text-transform: uppercase;
                            font-size: 0.8rem;
                            margin: 0 0 15px;
                        }

                        ul {
                            margin: 0;
                            padding: 0;
                            list-style: none;
                            li {
                                display: inline-block;
                                margin-right: 25px;
                                &:last-child {
                                    margin-right: 0px;
                                }
                                a {
                                    color: #ff9905;
                                    font-size: 1rem;
                                }
                            }
                        }
                    }
                    .email-container {
                        p {
                            margin: 0;

                            a {
                                color: #000;
                                font-weight: bold;
                                text-decoration: none;
                                font-size: 1rem;
                            }
                        }
                    }
                }
            }
        }
    }
    .copyright-container {
        ${media.medium`display: flex; max-width: 75vw;`}
        .text-container {
            flex: 1;
            display: block;
            margin-bottom: 40px;
            ${media.medium`display: flex;margin-bottom: 0px;`}
            p {
                color: #000;
                font-size: 0.8rem;
                margin: 0;
                &:first-child {
                    margin-right: 40px;
                }
            }
        }
        .links-container {
            flex: 1;
            display: flex;
            justify-content: flex-start;
            ${media.medium`justify-content: flex-end;`}
            ul {
                padding: 0;
                margin: 0;
                list-style: none;
                li {
                    display: inline-block;
                    margin-right: 30px;
                    &:last-child {
                        margin-right: 0px;
                    }
                    a {
                        color: #000;
                        font-size: 0.8rem;

                        &:hover {
                            opacity: 0.7;
                        }
                    }
                }
            }
        }
    }
`;
const FooterStyles = ({ children }) => {
    return <FooterStylesContainer>{children}</FooterStylesContainer>;
};

export default FooterStyles;
